// import Container from 'react-bootstrap/Container';
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
import styled from "styled-components";
import Offcanvasnav from "../components/OffCanvas/OffCanvas";
import SetSeoMeta from "../components/Seo/Seo";

const TextDiv = styled.div`
  // display: flex;
  // flex-direction: row;
  width: 50%;
  margin: auto;
  padding: 40px;
  text-align: center;
  font-size: 18px;
  // align-self: right;
  /* border: 2px orange solid; */
`;

const Headline2 = styled.h2`
  text-align: center;
`;

export default function ImpressumPage() {
  return (
    <>
      <SetSeoMeta
        title='1731 - Impressum'
        description='Hier findest Du unsere Kontaktdaten'
        name='Totengilde Blekendorf von 1731'
        type='article'
      />
      <Offcanvasnav></Offcanvasnav>
      <TextDiv>
        <h1 style={{ textAlign: "center" }}>Impressum</h1>
        <span>
          Totengilde Blekendorf von 1731
          <br />
          Achtern Beeck 5<br />
          24327 Blekendorf
        </span>
      </TextDiv>
      <TextDiv>
        <Headline2>Ältermann:</Headline2>
        <span>
          Andreas Bastian
          <br />
          Tel.: 0152 55292668<br />
          <a style={{ textDecoration: "none" }} href="mailto:totengilde-blekendorf@outlook.de">Schreib der Gilde eine Mail <br />(totengilde-blekendorf@outlook.de)</a>
        </span>
      </TextDiv>
      <TextDiv>
        <Headline2>Gestaltung und technische Umsetzung der Website</Headline2>
        <span>Udo Radü Makes IT<br />
          <a style={{ textDecoration: "none" }} href="mailto:makes-it@radue.net">Schreib dem Webadmin</a>
        </span>
      </TextDiv>
      <TextDiv>
        <Headline2>Copyright Totengilde Blekendorf von 1731</Headline2>
        <span>
          Alle Inhalte (einschließlich Texten, Bildern, Grafiken, Video- und
          Animationsdateien sowie des Designs) unterliegen dem Schutz des
          Urheberrechts und anderer Schutzgesetze, soweit nicht abweichend
          vermerkt. Eine Nutzung des Materials ist nach Absprache möglich. Bitte
          wenden Sie sich hierzu an unseren Vorstand: <a style={{ textDecoration: "none" }} href="mailto:totengilde-blekendorf@outlook.de">totengilde-blekendorf@outlook.de<br /></a> Die
          Vervielfältigung, Weitergabe, Wiederverwendung, Übertragung,
          Speicherung, Veränderung oder sonstige Nutzung der Inhalte zu
          gewerblichen oder öffentlichen Zwecken ist nur mit schriftlicher
          Zustimmung durch die Totengilde Blekendorf von 1731 möglich.
          {/* Einige Bilder, die auf dieser Website Verwendung finden, stammen von Drittanbietern - nachfolgend finden Sie eine Auflistung der Bildnachweise. */}
        </span>
      </TextDiv>
      <TextDiv>
        <Headline2>HAFTUNGSAUSSCHLUSS</Headline2>
        <span>
          Wir, die Totengilde Blekendorf von 1731, bemühen uns, dass die
          Daten/Informationen auf unserer Website richtig und zutreffend sind.
          Eine Garantie oder gar Haftung für die Aktualität, Richtigkeit und
          Vollständigkeit der Daten/Informationen ist ausgeschlossen. Auch die
          Inhalte der via Hyperlink verwiesenen Websites werden sorgfältig
          geprüft. Wir übernehmen jedoch keine Haftung für die Inhalte der mit
          oder von unserer Website verlinkten externen Seiten.
          <br />
          Sämtliche Daten/Informationen, ihre Nutzung, die Anmeldung zur
          Gilde-Website und sämtliches mit der Gilde-Website zusammenhängendes
          Tun, Dulden oder Unterlassen unterliegen ausschließlich deutschem
          Recht. Erfüllungsort und ausschließlicher Gerichtsstand ist Plön.
        </span>
      </TextDiv>

      {/* 
    <Container>
      <Row>
        <Col>
          <h3>Impressum</h3>
          Totengilde Blekendorf von 1731<br/>
          Achtern Beeck 5<br/>
          24327 Blekendorf
        </Col>
        <Col>2 of 2</Col>
      </Row>
      <Row>
        <Col>1 of 3</Col>
        <Col>2 of 3</Col>
        <Col>3 of 3</Col>
      </Row>
    </Container> */}
    </>
  );
}
